import { HttpHeaders, HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, forkJoin, throwError } from 'rxjs';
import { Response } from '../entities/response';
import { environment } from 'src/environments/environment';

export class Service {

	public baseURL: string;

	public optionsData = {
		headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': 'application/json' })
	};
	
	public optionsResponse = {
		headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': 'application/json' }),
		observe: 'response' as 'body'
	};

	constructor(private httpClient: HttpClient, url: string) {
		this.baseURL = url;
	}

	getAll<T>(URL: string, params?: string[]): Observable<T[]> {
		const resultObservable = new Observable<T[]>(
			observer => {
				this.getCount<T>(URL, environment.size_api_limit, 0, params).subscribe(
					(response: HttpResponse<T[]>) => {
						let arrayT = new Array();

						const totalCountHeaderValues: number = parseInt( response.headers.get('x-total-count'));
						const totalPages = Math.ceil(totalCountHeaderValues / environment.size_api_limit);

						if (totalPages === 0) {
							arrayT = arrayT.concat(response.body);
							observer.next(arrayT);
							observer.complete();
						} else {
							arrayT = arrayT.concat(response.body);

							if (totalPages === 1) {
								observer.next(arrayT);
							} else {
								const calls = [];

								for (let i = 1; i < totalPages; i++) {
									calls.push(this.getPageForAll<T>(URL, environment.size_api_limit, i, params));
								}

								forkJoin(calls).subscribe(join => {
									join.forEach(respuesta => {
										const aux: any = respuesta;
										arrayT = arrayT.concat(aux.body);
									});
			
									observer.next(arrayT);
								});
							}
						}
					}, error =>{
						observer.error(error);
					}
				);
			}
		);

		return resultObservable;
	}

  get<T>(URL: string, params?: string[]): Observable<T> {
    if (params){
      URL = URL + '?';
      params.forEach(element => {
        URL = URL + element + '&';
      });
      URL = URL.slice(0, -1);
    }
    return this.httpClient.get<T>(URL, this.optionsData);
  }

  getPag<T>(URL: string, size: number, page: number, params?: string[]): Observable<Response<T>> {
    URL = URL + '?size=' + size + '&page=' + page;
    if (params){
      params.forEach(element => {
        URL = URL + '&' + element ;
      });
    }
    const resultObservable = new Observable<Response<T>>(observer => {
      this.httpClient.get<HttpResponse<T[]>>(URL, this.optionsResponse).subscribe((response: HttpResponse<T[]>) => {
        const result: Response<T> = new Response<T>();
        const totalCountHeaderValues = response.headers.get('x-total-count');

        result.count = parseInt( totalCountHeaderValues);
        result.data = response.body;

        observer.next(result);
      }, error =>{
        observer.error(error);
      });
    });
    return resultObservable;
  }

  getPageForAll<T>(URL: string, size: number, page: number, params?: string[]): Observable<T[]> {
    URL = URL + '?size=' + size + '&page=' + page;
    if (params){
      params.forEach(element => {
        URL = URL + '&' + element ;
      });
    }
    return this.httpClient.get<T[]>(URL, this.optionsResponse);
  }

  getCount<T>(URL: string, size: number, page: number, params?: string[]): Observable<HttpResponse<T[]>> {
    URL = URL + '?size=' + size + '&page=' + page;
                
    if (params){
      params.forEach(element => {
        URL = URL + '&' + element ;
      });
    }
    return this.httpClient.get<HttpResponse<T[]>>(URL, this.optionsResponse);
  }

  getBlob(URL: string): Observable<any> {
    const optionsBlob = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': 'application/json' }),
      responseType: 'blob' as 'json'
    };
    return this.httpClient.get(URL, optionsBlob);
  }

  postImage(URL: string, data): Observable<any> {
    const optionsBlob = {
      headers: new HttpHeaders({})
    };
    return this.httpClient.post(URL, data, optionsBlob);
  }

  patch<T>(URL: string, object: T): Observable<T> {
    console.log("vamos a patchear");
    return this.httpClient.patch<T>(URL, object, this.optionsData);
  }

  put<T>(URL: string, object: T): Observable<T> {
    return this.httpClient.put<T>(URL, object, this.optionsData);
  }

  delete<T>(URL: string): Observable<T> {
    return this.httpClient.delete<T>(URL, this.optionsData);
  }

  post<T>(URL: string, data): Observable<T> {
    
    return this.httpClient.post<T>(URL, data, this.optionsData);
  }
}